import { Col, Container, Image, Row } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toWebp } from "../../../utils/common";
import Link from "next/link";
import styles from "./style.module.scss";
import HocButton from "../../HigherOrderComponent/HocButton";

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const CaseStudies = ({ data }) => {
	const caseStudies = data?.case_studies?.data;



	const renderTooltip = (props, technology) => (
		<Tooltip
			className={styles["case-tool-tip"]}
			id="button-tooltip"
			{...props}
		>
			<p>{technology?.title}</p>
			<span>{technology?.display_title}</span>
		</Tooltip>
	);

	return (
		<section
			className={`${styles["case-studies-new-section"]} ${styles["technology-case-study-section"]} bg-one home-padding-new`}
		>
			<Container className={styles["container"]}>
				<Row>
					<Col lg={12}>
						<div className={styles["casestudies-new-content"]}>
							<h2 className="text-black">{data?.title}</h2>
						</div>
					</Col>
					{caseStudies?.map(({ attributes, id }) => {
						const caseStudyAboutClient = attributes?.blocks?.find(
							(block) =>
								block?.__component === "blocks.about-client"
						);
						const tech = caseStudyAboutClient?.technologies[0];
						const desc =
							caseStudyAboutClient?.description?.length > 370
								? caseStudyAboutClient?.description.substring(
									0,
									370
								) + "... "
								: caseStudyAboutClient?.description + " ";
						// caseStudyAboutClient?.description

						return (
							<Col lg={12} key={id}>
								<div className={styles["case-studies-row"]}>
									<div className="row">
										<div className="col-lg-12">
											<div
												className={
													styles["case-studies-img"]
												}
											>
												<Image
													src={toWebp(
														`${baseUrl}${attributes?.image?.data?.attributes?.url}`
													)}
													alt={
														attributes?.image?.data
															?.attributes?.name
													}
												/>
												<div
													className={
														styles[
														"case-study-button-div"
														]
													}
												>
													<Link
														className="btn btn-primary btn-primary-md"
														href={`/case-studies/${attributes?.slug}`}
													>
														View Case Study
													</Link>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<div
												className={
													styles[
													"case-studies-content"
													]
												}
											>
												<div className="row">
													<div className="col-lg-7 col-md-6">
														<div
															className={
																styles[
																"case-studies-content-left"
																]
															}
														>
															{attributes?.case_study_tag && (
																<div
																	className={
																		styles[
																		"techn-inno-button-div"
																		]
																	}
																>
																	<a
																		className={`btn ${styles["techn-inno-btn"]}`}
																		href="#"
																	>
																		<span>
																			{
																				attributes?.case_study_tag
																			}
																		</span>
																	</a>
																</div>
															)}
															<div
																className={
																	styles[
																	"case-studies-text-card"
																	]
																}
															>
																<h3 className="h4 text-black">
																	{
																		attributes?.title
																	}
																</h3>
																<p className="text-small font-regular">
																	{desc}
																	<Link className="link link-primary"
																		href={`/case-studies/${attributes?.slug}`}
																	>
																		read
																		more
																	</Link>
																</p>
															</div>
														</div>
													</div>
													<div className="col-lg-5 col-md-6">
														<div
															className={
																styles[
																"case-studies-content-right"
																]
															}
														>
															<div className="row g-3">
																{caseStudyAboutClient?.key_points?.map(
																	(point) => (
																		<div
																			className="col-lg-6 col-md-6 col-sm-6 col-6"
																			key={
																				point?.id
																			}
																		>
																			<div
																				className={
																					styles[
																					"resources-nu-card"
																					]
																				}
																			>
																				<h4 className="text-small font-regular text-black">
																					{
																						point?.title
																					}
																				</h4>
																				<h3 className="text-medium font-semibold text-black">
																					{
																						point?.numbers
																					}
																				</h3>
																			</div>
																		</div>
																	)
																)}
																<div className="col-lg-12 col-md-12">
																	{tech?.technologies && (
																		<div
																			className={
																				styles[
																				"resources-nu-card"
																				]
																			}
																		>
																			<h4 className="text-small font-regular text-black">
																				{
																					tech?.title
																				}
																			</h4>
																			<ul
																				className={`${styles["stack-deployed-div"]} ${styles["justify-content-around"]}`}
																			>
																				{tech?.technologies?.map(
																					(
																						technology
																					) => (
																						<li
																							key={
																								technology.id
																							}
																						>
																							<OverlayTrigger
																								placement="top"
																								delay={{
																									show: 250,
																									hide: 400,
																								}}
																								overlay={(
																									props
																								) =>
																									renderTooltip(
																										props,
																										technology
																									)
																								}
																							>
																								<div
																									className={
																										styles[
																										"stack-deployed-img"
																										]
																									}
																									placement="right"
																								>
																									<Image
																										src={toWebp(
																											`${baseUrl}${technology?.image?.data?.attributes?.url}`
																										)}
																										alt={
																											technology
																												?.image
																												?.data
																												?.attributes
																												?.name
																										}
																									/>
																								</div>
																							</OverlayTrigger>
																						</li>
																					)
																				)}
																			</ul>
																		</div>
																	)}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Col>
						);
					})}
				</Row>
				{data?.button?.id &&
					<div className="text-center">
						<HocButton
							button={data?.button}
							btnAction={() => HandleClick()}
						>
							<Link
								href={data?.button?.href}
								className="mx-auto btn btn-primary decoration-none"
							>
								{data?.button?.label}
							</Link>
						</HocButton>
					</div>}
			</Container>
		</section>
	);
};

export default CaseStudies;

